import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mr-1" }

import Notice from '@/components/Notice.vue';
import TooltipIcon from '@/components/tooltip/TooltipIcon.vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'SwitchOffBalancesModeNotice',
  props: {
    color: null
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'click'): void;
}), expose: any, slots: any, attrs: any }) {

const { t } = useI18n();





const clickableTextTranslation = t(
  'portfolio.easyModeTranslations.common.notices.switchOff.clickableText',
);
const restTextTranslation = t('portfolio.easyModeTranslations.common.notices.switchOff.restText');
const tooltipTranslation = t('portfolio.easyModeTranslations.common.notices.switchOff.tooltipText');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Notice, { icon: "noAim" }, {
    "notice-text": _withCtx(() => [
      _createElementVNode("span", {
        class: "underline clickable mr-s1",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
      }, _toDisplayString(_unref(clickableTextTranslation)), 1),
      _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(restTextTranslation)), 1),
      _createVNode(TooltipIcon, {
        tooltip: _unref(tooltipTranslation),
        color: __props.color,
        "no-space": "",
        inline: ""
      }, null, 8, ["tooltip", "color"])
    ]),
    _: 1
  }))
}
}

})